// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"7b6f79ae","121":"a8005f3c"}[chunkId] + ".chunk.js";
};